<div class="container">
    <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
  <span class="icon"><i class="fas fa-city" aria-hidden="true"></i></span>{{ 'CityMaintenance.Header' | translate }}
  </h1>

  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [(selected)]="isSearchFormOpen"
      >

        <!-------------------------------------- Query Form ---------------------------------------------->
        <form [formGroup]="searchFormGroup" (ngSubmit)="searchBtnClick()">
          <div class="p-fluid formgrid grid">

            <!-------------------------------------- Country Slot ---------------------------------------------->
            <div class="col-6 field">
              <label for="formCountry">{{ 'CityMaintenance.Form.Country' | translate }}</label>
              <p-dropdown
                inputId="formCountry"
                formControlName="country"
                placeholder="{{ 'AssignmentDistrictMaintenance.Placeholder.OptionHint.SelectACountry' | translate }}"
                [filter]="true"
                [showClear]="true"
                [virtualScroll]="true"
                [itemSize]="40"
                [options]="countryOptions">
              </p-dropdown>
            </div>

            <!-------------------------------------- Name Slot ---------------------------------------------->
            <div class="col-6 field">
              <label for="formName">{{ 'CityMaintenance.Form.Name' | translate }}</label>
              <input pInputText
                type="text"
                maxlength="50"
                id="formName"
                formControlName="name"
              />
            </div>

            <!-------------------------------------- En Name Slot ---------------------------------------------->
            <div class="col-6 field">
              <label for="formEnName">{{ 'CityMaintenance.Form.EnName' | translate }}</label>
              <input pInputText
                type="text"
                maxlength="50"
                id="formEnName"
                formControlName="enName"
              />
            </div>

            <!-------------------------------------- Express Area Slot ---------------------------------------------->
            <div class="col-6 field">
              <label for="formExpressArea">{{ 'CityMaintenance.Form.ExpressArea' | translate }}</label>
              <input pInputText
                type="id"
                maxlength="50"
                id="formExpressArea"
                formControlName="expressArea"
              />
            </div>

          </div>

          <!-------------------------------------- Form Button ---------------------------------------------->
          <div>

             <!-------------------------------------- Query Button ---------------------------------------------->
            <button pButton
              type="submit"
              label="{{ 'Common.Button.Search' | translate }}"
            ></button>

             <!-------------------------------------- Reset Button ---------------------------------------------->
             <button pButton
              type="reset"
              label="{{ 'Common.Button.Reset' | translate }}"
              class="p-button-secondary ml-2"
            ></button>

          </div>

        </form>
      </p-accordionTab>
    </p-accordion>

    <!-------------------------------------- Table ---------------------------------------------->
    <p-table #table
      [columns]="selectedTableColumns"
      [value]="tableData"
      [loading]="isLoading"
      [resizableColumns]="true"
      [reorderableColumns]="true"

      [scrollable]="true"
      scrollHeight="500px"
      scrollDirection="both"

      [(selection)]="selectedRow"
      selectionMode="single"

      [lazy]="true"
      (onPage)="onTablePageChanging($event)"
      (onSort)="onTableSorting($event)"
      [resetPageOnSort]="false"

      [paginator]="true"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'Common.Table.PageSummary' | translate}}"
      [rows]="this.pageInfo.pageSize"
      [rowsPerPageOptions]="[5, 10, 20]"
      [totalRecords]="this.pageInfo.totalRecords"

      dataKey="dataKey"
      editMode="row"
      class="datatable"
      styleClass="p-datatable-gridlines p-datatable-stripped mt-2 white-space: nowrap;">

      <!-------------------------------------- Table Caption Part ---------------------------------------------->
      <ng-template pTemplate="caption">

        <!-------------------------------------- Display Column List ---------------------------------------------->
        <laas-table-column-toggle
          [optionsColumn]="tableColumns"
          [dataTable]="table">
        </laas-table-column-toggle>

        <!-------------------------------------- Add Button ---------------------------------------------->
        <button pButton
          class="p-button-success p-button-raised ml-2"
          label="{{ 'Common.Button.Add' | translate }}"
          icon="fa fa-plus"
          [disabled]="!isInEditMode"
          (click)="addNewRow()"
        ></button>

        <!-------------------------------------- Delete Button ---------------------------------------------->
        <button pButton
          class="p-button-danger p-button-raised ml-2"
          label="{{ 'Common.Button.Delete' | translate }}"
          icon="fas fa-trash-alt"
          [disabled]="!isInEditMode || tableData.length <= 0"
          (click)="deleteSelectedRow()"
        ></button>

        <!-------------------------------------- Save Button ---------------------------------------------->
        <button pButton
          class="p-button-raised ml-2"
          label="{{ 'Common.Button.Save' | translate }}"
          icon="fas fa-save"
          [disabled]="!isInEditMode"
          (click)="saveChanges()"
        ></button>

        <!-------------------------------------- Restore Button ---------------------------------------------->
        <button pButton
          class="p-button-secondary p-button-raised ml-2"
          label="{{ 'CityMaintenance.Table.Button.Restore' | translate }}"
          icon="fas fa-sync-alt"
          [disabled]="!isInEditMode"
          (click)="restoreTableDate()"
        ></button>

        <!-------------------------------------- Edit Button ---------------------------------------------->
        <button pButton
          style="color: white"
          class="p-button-warning p-button-raised ml-2"
          label="{{ isInEditMode ? ( 'Common.Button.Cancel' | translate ) : ( 'Common.Button.Edit' | translate ) }}"
          icon="fas fa-pen"
          (click)="switchEditMode()"
        ></button>
      </ng-template>

      <!-------------------------------------- Table Column Group Part ---------------------------------------------->
      <!---------------------------- Make columns as a group for horizontal scroll ---------------------------------------------->
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col *ngFor="let col of columns" style="width: 15vw">
        </colgroup>
      </ng-template>

      <!-------------------------------------- Table Header Part ---------------------------------------------->
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" pReorderableColumn pResizableColumn
            [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="!col.sort"
            scope="col">
            {{ col.header | translate }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <!-------------------------------------- Table Body Part ---------------------------------------------->
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="onRowSelect(rowData)">
          <ng-container [ngSwitch]="col.field" *ngFor="let col of columns">

            <!-------------------------------------- SeqNo Column ---------------------------------------------->
            <td *ngSwitchCase="'seqNo'">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith: '-' }}
              </div>
            </td>

            <!-------------------------------------- Country Column ---------------------------------------------->
            <td *ngSwitchCase="'country'">
              <p-cellEditor class="p-fluid">
                <ng-template pTemplate="input">
                  <p-dropdown
                    appendTo="body"
                    inputId="tableCountry"
                    placeholder="{{ 'CityMaintenance.Placeholder.OptionHint.SelectACountry' | translate }}"
                    [showClear]="true"
                    [filter]="true"
                    [options]="countryOptions"
                    [(ngModel)]="rowData[col.field]"
                  ></p-dropdown>
                  <small *ngIf="!rowData[col.field]" class="alert">
                    <div class="p-invalid">
                      {{ 'CityMaintenance.Warning.CountryRequired' | translate }}
                    </div>
                  </small>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- Name Column ---------------------------------------------->
            <td *ngSwitchCase="'name'">
              <p-cellEditor class="p-fluid">
                <ng-template pTemplate="input">
                  <label for="tableName"></label>
                  <input pInputText
                    type="text"
                    maxlength="50"
                    id="tableName"
                    [(ngModel)]="rowData[col.field]"
                  />
                  <small *ngIf="isNameInvalid(rowData[col.field])" class="alert">
                    <div class="p-invalid">
                      {{ 'CityMaintenance.Warning.NameRequired' | translate }}
                    </div>
                  </small>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- En Name Column ---------------------------------------------->
            <td *ngSwitchCase="'enName'">
              <p-cellEditor class="p-fluid">
                <ng-template pTemplate="input">
                  <label for="tableEnName"></label>
                  <input pInputText
                    type="text"
                    maxlength="50"
                    id="tableEnName"
                    [(ngModel)]="rowData[col.field]"
                  />
                  <small *ngIf="isEnNameInvalid(rowData[col.field])" class="alert">
                    <div class="p-invalid">
                      {{ 'CityMaintenance.Warning.EnNameRequired' | translate }}
                    </div>
                  </small>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: '-' }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- Express Area Column ---------------------------------------------->
            <td *ngSwitchCase="'expressArea'">
              <p-cellEditor class="p-fluid">
                <ng-template pTemplate="input">
                  <label for="tableExpressArea"></label>
                  <input pInputText
                    type="text"
                    maxlength="50"
                    id="tableExpressArea"
                    [(ngModel)]="rowData[col.field]"
                  />
                  <small *ngIf="isExpressAreaInvalid(rowData[col.field])" class="alert">
                    <div class="p-invalid">
                      {{ 'CityMaintenance.Warning.ExpressAreaRequired' | translate }}
                    </div>
                  </small>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: '-'}}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- Create User Column ---------------------------------------------->
            <td *ngSwitchCase="'createUser'">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith: '-' }}
              </div>
            </td>

            <!-------------------------------------- CreateDt Column ---------------------------------------------->
            <td *ngSwitchCase="'createDt'">
              <div class="overflow-text">
                {{ rowData[col.field] | date: 'YYYY-MM-dd HH:mm:ss' | replaceNullWith: '-' }}
              </div>
            </td>

            <!-------------------------------------- Update User Column ---------------------------------------------->
            <td *ngSwitchCase="'updateUser'">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith: '-' }}
              </div>
            </td>

             <!-------------------------------------- UpdateDt Column ---------------------------------------------->
             <td *ngSwitchCase="'updateDt'">
              <div class="overflow-text">
                {{ rowData[col.field] | date: 'YYYY-MM-dd HH:mm:ss' | replaceNullWith: '-' }}
              </div>
            </td>

          </ng-container>
        </tr>
      </ng-template>

      <!-------------------------------------- Table Empty Message Part ---------------------------------------------->
      <!-------------------------------------- Message for empty table ---------------------------------------------->
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            {{ "Common.Table.NoData" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>

  </p-card>
</div>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
